// Visual surfaces for the canonical-trust tier.
//
//   <TierDot tier="green" />          inline 8px swatch
//   <TierBadge tier="grey" />         kicker + blurb pill (proposal card etc.)
//
// Pulled out into its own module so any surface that displays a
// canonical (KitchenCard, AxisStack canonical chip, Wizard tile,
// IngredientCard, ProposalCard) can drop the same swatch in without
// re-rolling the palette.

import { TIER_COLOR, TIER_KICKER, TIER_BLURB } from "./canonicalTier";

export function TierDot({ tier = "grey", size = 8, title }) {
  const color = TIER_COLOR[tier] || TIER_COLOR.grey;
  return (
    <span
      title={title || TIER_KICKER[tier]}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        background: `radial-gradient(circle at 30% 25%, rgba(255,255,255,0.30) 0%, rgba(255,255,255,0) 55%), ${color}`,
        boxShadow: `0 1px 2px rgba(30,20,8,0.25), inset 0 1px 0 rgba(255,255,255,0.30)`,
        flexShrink: 0,
      }}
    />
  );
}

// Larger badge for the proposal-card / explainer surfaces. Carries
// kicker + blurb text and the colored dot.
export function TierBadge({ tier = "grey", showBlurb = true }) {
  const color = TIER_COLOR[tier] || TIER_COLOR.grey;
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "6px 10px",
      borderRadius: 999,
      background: `${color}1a`,
      border: `1px solid ${color}55`,
      fontFamily: "'DM Mono',monospace",
      fontSize: 10,
      letterSpacing: "0.10em",
      color: color,
      whiteSpace: "nowrap",
    }}>
      <TierDot tier={tier} size={9} />
      <span style={{ fontWeight: 600, textTransform: "uppercase" }}>
        {TIER_KICKER[tier]}
      </span>
      {showBlurb && (
        <span style={{
          fontFamily: "'DM Sans',sans-serif",
          fontSize: 11,
          textTransform: "none",
          letterSpacing: "0",
          color: "#666",
          fontWeight: 400,
        }}>
          {TIER_BLURB[tier]}
        </span>
      )}
    </div>
  );
}
